<template>
	<div>
		<div style="text-align: left; padding-bottom: 10px;">
			<el-row :gutter="2">
					<el-col :span="6">
						
						<el-button type="primary" @click="networkUpdate">添加网点</el-button>
						
					</el-col>
					<el-col :span="6">
						
							<el-input v-model="name" class="" placeholder="网点名称"></el-input>
						
					</el-col>
					<el-col :span="12">
						
						<el-button type="primary" @click="searchNetWork">查询</el-button>
						
					</el-col>
				</el-row>
			
		</div>
		<el-table :data="tableData" style="width: 100%" border stripe>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
      		<el-table-column prop="name" label="网点名称" width="180"></el-table-column>
      		<el-table-column prop="telephone" label="联系电话" width="150"></el-table-column>
      		<el-table-column prop="address" label="地址" width="120"></el-table-column>
      		<el-table-column prop="cityName" label="所在城市" width="120"></el-table-column>
      		<el-table-column prop="longitude" label="经度" width="100"></el-table-column>
      		<el-table-column prop="latitude" label="纬度" width="100"></el-table-column>
      		<el-table-column prop="state" label="状态" width="80">
	      			<template slot-scope="scope">
      				<el-tag v-if="scope.row.state==0" type="danger">无效</el-tag>
      				<el-tag v-if="scope.row.state==1" type="success">有效</el-tag>
      			</template>
      		</el-table-column>	
      		<el-table-column label="操作" width="180">
      			<template scope="scope">
					<el-button size="small" v-if="scope.row.state==0" @click="visibleNetwork(scope.$index, scope.row)">置为有效</el-button>
					<el-button size="small" v-if="scope.row.state==1" @click="visibleNetwork(scope.$index, scope.row)">置为无效</el-button>
					<el-button size="small" @click="networkUpdate(scope.$index, scope.row)">修改</el-button>
				</template>
      		</el-table-column>
      	</el-table>
      	<el-pagination background ayout="prev, next" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
		</el-pagination>


		
	</div>

	
</template>
<script >
	import {getNetworkList,visibleNetwork} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		pageSize:15,
		 		total:0,
		 		pageCount:0,
		 		name:''
		 	}
		},
		created:function() {
			var _this = this;
			let params = {pageNum:0,pageSize:this.pageSize};
			getNetworkList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
			});
			
		},
		methods:{
			searchNetWork(){
				this.reload();
			},
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize};
				getNetworkList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
				});
			},
			networkUpdate(index,row){
				var param = {};
				if(row!=null){
					param.id = row.id;
				}
				this.$router.push({name:"networkUpdate",query:param});
			},
			reload(){
				console.log("reload");
				let params = {pageNum:this.currentPage,pageSize:this.pageSize,name:this.name};
				getNetworkList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			visibleNetwork(index,row){
				let _this = this;
				let params={id:row.id};
				if(row.state==1){
					params.state=0;
				}else{
					params.state=1;
				}
				visibleNetwork(params).then(res=>{
					if(res.data.status=='success'){
						this.$message({
					            type: 'success',
					            message: '操作成功'
					         });
						_this.reload();
					}
				});
			}
		}
	}
</script>